import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(data = null) {
        if (!data || Object.keys(data).length === 0) {
            return axios.get(`${API_URL}/service-orders`, { headers: authHeader() });
        }
        const queryString = new URLSearchParams(data).toString();
        return axios.get(`${API_URL}/service-orders?${queryString}`, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/service-orders/${id}`, { headers: authHeader() });
    },
    createData(data) {
        return axios.post(`${API_URL}/service-orders`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/service-orders/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/service-orders/${id}`, { headers: authHeader() });
    },
    getDoc(id) {
        return axios.get(`${API_URL}/service-orders/export-pdf/${id}`, {
            headers: authHeader(),
            responseType: "blob",
        });
    },
    getPublicPdfLink(id) {
        return axios.get(`${API_URL}/service-orders/public-pdf-link/${id}`, {
            headers: authHeader(),
        });
    },
    getMotorcycleCatalog(brand = '') {
        const params = brand ? { brand } : {};
        return axios.get(`${API_URL}/service-orders/motorcycle-catalog`, {
            headers: authHeader(),
            params,
        });
    },
};
